import { render, staticRenderFns } from "./ModalChangeConceptStatus.vue?vue&type=template&id=ef2ad0bc&lang=pug&"
import script from "./ModalChangeConceptStatus.vue?vue&type=script&lang=js&"
export * from "./ModalChangeConceptStatus.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeConceptStatus.vue?vue&type=style&index=0&id=ef2ad0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports